import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import styles from "./OutletAccordion.module.scss";
import baseStyles from "../../ProductAccordion.module.scss";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
type Props = {
  open: boolean | undefined;
};

export const OUTLET_ACCORDION_INSTANCE_NAME = "outlet";

export function OutletAccordionUI({ open }: Props) {
  const [isOpen, setIsOpen] = useState(open);
  return (
    <ProductAccordionWithMonetateEvents name="Outlet" open={isOpen}>
      <AccordionItem
        className={styles["product-accordion__item"]}
        data-testid="accordion:outlet"
        header={<h2 className={baseStyles.accordionTitle}>Outlet</h2>}
        isOpen={open}
        id="accordion-outlet"
        instanceName={OUTLET_ACCORDION_INSTANCE_NAME}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div className={styles.outlet}>
          <span className={styles.heading}>
            Good as new returned items with up to 30% off
          </span>
          <p>
            Everything in our Outlet has been thoroughly checked by our expert
            Partners to make sure they meet our quality standards. They can be
            returned within 30 days and have the same guarantees as our new,
            full price items.
          </p>
          <span className={styles.heading}>Certified: Like new</span>
          <p>
            Meaning perfect condition, no bumps, scratches or marks. Usually
            only the box has been opened, or the item&apos;s been repackaged.
          </p>
        </div>
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}
